import styled from "styled-components";

export default styled.div`
    display: flex;

    & button:nth-child(2) {
        margin-left: 12px;
    }
`;
